import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const radioGroupTableStyles = makeStyles((theme) => ({
    radioGroupTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        borderRadius: '3px',
        '& .radio-table': {
            '&-content': {
                '& > .radio-table-row': {
                    '&:nth-child(even)': {
                        backgroundColor: tcsmColors.greySeven,
                    },
                },
            },
            '&-row': {
                padding: theme.spacing(.75),

                [theme.breakpoints.up('sm')]: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    width: '100%',
                    maxWidth: '100%',
                    padding: '0',
                },
                '&-label': {
                    [theme.breakpoints.up('sm')]: {
                        display: 'none',
                    },
                },
                '&-cell': {
                    

                    [theme.breakpoints.up('sm')]: {
                        display: 'block',
                        whiteSpace:'nowrap',
                        margin: '0',
                        padding: theme.spacing(.75),
                        '& .MuiRadio-root': {
                            padding: '0',
                        },
                    },

                    '&-desktop-title': {
                        display: 'none',
                        [theme.breakpoints.up('sm')]: {
                            textAlign: 'left',
                            display: 'block',
                        },
                    },

                },


            },
            '&-input': {
                '&-label': {
                    [theme.breakpoints.up('sm')]: {
                        marginLeft: theme.spacing(.5),
                    },
                },
            },
        },
    },
}));



